// Acreditación — algoritmo original, extraído sin modificar de js/acreditacion.js.
// Usa la fecha del formulario (dd-mm-yyyy), no la del sistema.
// Verificado contra tools/caracterizacion/golden.json.

export function validar({ fecha }) {
  if (!fecha || String(fecha).trim() === '') {
    return 'Falta la fecha';
  }
  return null;
}

export function calcular({ tipoFactura, fecha, puesto, nroFactura }) {
  const Factura_Puesto = parseInt(puesto, 10);
  const Factura_Numero = parseInt(nroFactura, 10);

  const FechaSep = String(fecha).split('-');
  const Dia = parseInt(FechaSep[0], 10);
  const Mes = parseInt(FechaSep[1], 10);
  const Anio = parseInt(FechaSep[2], 10);

  let Resultado = Dia * 15 + Mes * 56 + Anio;
  Resultado = Resultado * (tipoFactura == 'FCA' ? 215 : 714);

  if (Factura_Puesto % 2 == 0) {
    if (Factura_Numero % 2 == 0) {
      Resultado += Factura_Puesto * Dia * 13 + Factura_Numero * 145 * Mes;
    } else {
      Resultado += Factura_Puesto * 316 + Factura_Numero * 113 * Dia;
    }
  } else {
    if (Factura_Numero % 2 == 0) {
      Resultado += Factura_Puesto * 71 + Factura_Numero * Mes * 21;
    } else {
      Resultado += Factura_Puesto * Mes * 97 + Factura_Numero * 37 * Dia;
    }
  }

  Resultado = Resultado % 10000;

  return {
    codigo: Resultado,
    detalle: {
      fechaFactura: fecha,
      tipoFactura,
      puesto: String(puesto),
      nroFactura: String(nroFactura),
    },
  };
}
